import { useRequest } from '@Hooks/useRequest';
import { API } from '@Services';
import { PagedResponse, Project } from '@Types';
import { useCallback } from 'react';

interface GetFundProjectsProps {
  detailedProjectStatus?: string | string[];
}

export const useGetFundProjects = () => {
  const [fetch, response] = useRequest<PagedResponse<Project>>();

  const getFundProjects = useCallback(
    (fundId: number, { detailedProjectStatus }: GetFundProjectsProps = {}) => {
      const statusParam = detailedProjectStatus
        ? Array.isArray(detailedProjectStatus)
          ? detailedProjectStatus.join(',')
          : detailedProjectStatus
        : undefined;

      return fetch(API.paths.fund_projects(fundId), 'get', {
        params: {
          detailed_project_status: statusParam,
          // Django rest framework doesn't give us an easy way to disable pagination, this is a temporary workaround.
          limit: 999,
        },
      });
    },
    [fetch],
  );

  return [getFundProjects, response] as const;
};
